import { OrderItem } from '../../../components/orderItem';
import { Order } from '../../../core/types/order';
import { OrderItemTitleVariant, useConvertClothing } from './useConvertClothing';

export const ClothingOrderItem = ({
  order,
  titleVariant = 'User ID',
}: {
  order: Order,
  titleVariant?: OrderItemTitleVariant,
}) => {
  const data = useConvertClothing(order, titleVariant);
  return (
    <OrderItem order={data} />
  );
};
